import moment from "moment";
import { useState } from "react";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";

function ErrorModal({ error, startTime }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)


  return (
    <>
      <button className="btn btn-danger " style={{ padding: '6px' }} onClick={handleShow}>
        Error
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        size="xl"
      >
        <Modal.Header >
          <Modal.Title>Last Error :- {moment(startTime).format('lll')} </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <pre>{error}</pre>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>

        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ErrorModal;
